export default "__VITE_ASSET__Bcf_xqbD__"